export const VIDEO_TOKEN = 'VIDEO_TOKEN'
export const VIDEO_TOKEN_RESPONSE = 'VIDEO_TOKEN_RESPONSE'
export const REQUEST_CANCEL = 'REQUEST_CANCEL'
export const LOG_OUT = 'LOG_OUT'
export const LOG_OUT_RES = 'LOG_OUT_RES'
export const CHAT_HISTORY ='CHAT_HISTORY'
export const CHAT_HISTORY_RES ='CHAT_HISTORY_RES'
